import Vue from 'vue';
import zhCN from './lang/zh-cn';
var state = Vue.observable({
  lang: 'zh-cn',
  message: zhCN
});
window.locale = state;
export default {
  message: function message() {
    return state.message;
  },
  lang: function lang() {
    return state.lang;
  },
  use: function use(data) {
    state.lang = data.locale;
    state.message = data;
  },
  create: function create(componentName) {
    return {
      t: function t(key) {
        var componentLocale = state.message[componentName] || {};
        return componentLocale[key] || state.message[key];
      }
    };
  }
};